import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

export default class MoveTeamDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.moveDialogOpen}
        onClose={this.props.toggleMoveDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.teams.moveTeamToDivision}
        </DialogTitle>
        <DialogContent
          style={{ width: 350, maxWidth: "97%", paddingBottom: 0 }}
        >
          <DialogContentText>
            {languages.formatString(
              languages.teams.moveDescription,
              this.props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
          </DialogContentText>
        </DialogContent>
        <DialogContent style={{ width: 350, maxWidth: "97%" }}>
          <List component="nav">
            {this.props.divisions.map(division => {
              return (
                <ListItem
                  key={division.id}
                  button
                  onClick={() => {
                    this.props.handleMoveSelected(division.id);
                  }}
                  disabled={
                    this.props.division.id === division.id ||
                    this.props.moveButtonDisabled
                  }
                >
                  <ListItemText primary={division.name} />
                </ListItem>
              );
            })}
          </List>
        </DialogContent>

        <DialogActions>
          <Button onClick={this.props.toggleMoveDialog} color="primary">
            {languages.general.cancel}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
